import { useSelector } from '@xstate/react';

import { useMainMachine } from './useMainMachine';
import { PUBLISH_MACHINE_ID } from '../state';

export function usePublishMachine() {
  const { useSelector: useMainSelector } = useMainMachine();

  const publishMachine = useMainSelector((state) => state.children[PUBLISH_MACHINE_ID]?.ref);

  const usePublishMachineSelector = (...props) => useSelector(publishMachine, ...props);
  return { usePublishMachineSelector, publishMachine };
}
